export const enum DirectoryView {
  EXPLORE = "explore",
  MY_PROJECTS = "my-projects",
  MADE_FOR_YOU = "made-for-you",
}
